import { render, staticRenderFns } from "./reportPreview.vue?vue&type=template&id=64d0963a&scoped=true&"
import script from "./reportPreview.vue?vue&type=script&lang=js&"
export * from "./reportPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0963a",
  null
  
)

export default component.exports